/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as X402UsageRouteImport } from './routes/x402-usage'
import { Route as WarehouseRouteImport } from './routes/warehouse'
import { Route as TreasuryRouteImport } from './routes/treasury'
import { Route as TradeInAnalyticsRouteImport } from './routes/trade-in-analytics'
import { Route as TakebackDashboardRouteImport } from './routes/takeback-dashboard'
import { Route as StoresRouteImport } from './routes/stores'
import { Route as SponsoredRouteImport } from './routes/sponsored'
import { Route as ShopifyTradeInsRouteImport } from './routes/shopify-trade-ins'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RouteTesterRouteImport } from './routes/route-tester'
import { Route as RevenueRouteImport } from './routes/revenue'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as PricingEngineRouteImport } from './routes/pricing-engine'
import { Route as PinRouteImport } from './routes/pin'
import { Route as NespressoAnalyticsRouteImport } from './routes/nespresso-analytics'
import { Route as MarketIntelligenceRouteImport } from './routes/market-intelligence'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as ConversationalAnalyticsRouteImport } from './routes/conversational-analytics'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as CampaignAnalyticsRouteImport } from './routes/campaign-analytics'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WarehouseIndexRouteImport } from './routes/warehouse.index'
import { Route as WarehouseOverviewRouteImport } from './routes/warehouse.overview'
import { Route as StoresIdRouteImport } from './routes/stores_.$id'
import { Route as SponsoredIdRouteImport } from './routes/sponsored_.$id'
import { Route as SettingsShopifyRouteImport } from './routes/settings_.shopify'
import { Route as ProgramsIdRouteImport } from './routes/programs_.$id'
import { Route as ProductsImportRouteImport } from './routes/products_.import'
import { Route as ProductsIdRouteImport } from './routes/products_.$id'
import { Route as PinUsageRouteImport } from './routes/pin_.usage'
import { Route as PinIdRouteImport } from './routes/pin_.$id'
import { Route as KnowledgeTestRouteImport } from './routes/knowledge_.test'
import { Route as KnowledgeNewRouteImport } from './routes/knowledge_.new'
import { Route as KnowledgeIdRouteImport } from './routes/knowledge_.$id'
import { Route as DocsProductsRouteImport } from './routes/docs_.products'
import { Route as DocsIntegrationsRouteImport } from './routes/docs_.integrations'
import { Route as DocsGettingStartedRouteImport } from './routes/docs_.getting-started'
import { Route as CampaignsIdRouteImport } from './routes/campaigns_.$id'
import { Route as WarehousePackageIdRouteImport } from './routes/warehouse_.package_.$id'
import { Route as StoresStoreIdRouteImport } from './routes/stores_.store_.$id'
import { Route as ProgramsIdTakebacksRouteImport } from './routes/programs_.$id_.takebacks'
import { Route as ProgramsIdResaleRouteImport } from './routes/programs_.$id_.resale'
import { Route as ProgramsIdDashboardRouteImport } from './routes/programs_.$id_.dashboard'
import { Route as ProgramsIdAnalyticsRouteImport } from './routes/programs_.$id_.analytics'
import { Route as PinTakebackIdRouteImport } from './routes/pin_.takeback_.$id'
import { Route as PinResaleIdRouteImport } from './routes/pin_.resale_.$id'

const X402UsageRoute = X402UsageRouteImport.update({
  id: '/x402-usage',
  path: '/x402-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const WarehouseRoute = WarehouseRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryRoute = TreasuryRouteImport.update({
  id: '/treasury',
  path: '/treasury',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeInAnalyticsRoute = TradeInAnalyticsRouteImport.update({
  id: '/trade-in-analytics',
  path: '/trade-in-analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const TakebackDashboardRoute = TakebackDashboardRouteImport.update({
  id: '/takeback-dashboard',
  path: '/takeback-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const StoresRoute = StoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsoredRoute = SponsoredRouteImport.update({
  id: '/sponsored',
  path: '/sponsored',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopifyTradeInsRoute = ShopifyTradeInsRouteImport.update({
  id: '/shopify-trade-ins',
  path: '/shopify-trade-ins',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RouteTesterRoute = RouteTesterRouteImport.update({
  id: '/route-tester',
  path: '/route-tester',
  getParentRoute: () => rootRouteImport,
} as any)
const RevenueRoute = RevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingEngineRoute = PricingEngineRouteImport.update({
  id: '/pricing-engine',
  path: '/pricing-engine',
  getParentRoute: () => rootRouteImport,
} as any)
const PinRoute = PinRouteImport.update({
  id: '/pin',
  path: '/pin',
  getParentRoute: () => rootRouteImport,
} as any)
const NespressoAnalyticsRoute = NespressoAnalyticsRouteImport.update({
  id: '/nespresso-analytics',
  path: '/nespresso-analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketIntelligenceRoute = MarketIntelligenceRouteImport.update({
  id: '/market-intelligence',
  path: '/market-intelligence',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationalAnalyticsRoute = ConversationalAnalyticsRouteImport.update({
  id: '/conversational-analytics',
  path: '/conversational-analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignAnalyticsRoute = CampaignAnalyticsRouteImport.update({
  id: '/campaign-analytics',
  path: '/campaign-analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WarehouseIndexRoute = WarehouseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WarehouseRoute,
} as any)
const WarehouseOverviewRoute = WarehouseOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => WarehouseRoute,
} as any)
const StoresIdRoute = StoresIdRouteImport.update({
  id: '/stores_/$id',
  path: '/stores/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SponsoredIdRoute = SponsoredIdRouteImport.update({
  id: '/sponsored_/$id',
  path: '/sponsored/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsShopifyRoute = SettingsShopifyRouteImport.update({
  id: '/settings_/shopify',
  path: '/settings/shopify',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsIdRoute = ProgramsIdRouteImport.update({
  id: '/programs_/$id',
  path: '/programs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsImportRoute = ProductsImportRouteImport.update({
  id: '/products_/import',
  path: '/products/import',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIdRoute = ProductsIdRouteImport.update({
  id: '/products_/$id',
  path: '/products/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PinUsageRoute = PinUsageRouteImport.update({
  id: '/pin_/usage',
  path: '/pin/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const PinIdRoute = PinIdRouteImport.update({
  id: '/pin_/$id',
  path: '/pin/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeTestRoute = KnowledgeTestRouteImport.update({
  id: '/knowledge_/test',
  path: '/knowledge/test',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeNewRoute = KnowledgeNewRouteImport.update({
  id: '/knowledge_/new',
  path: '/knowledge/new',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeIdRoute = KnowledgeIdRouteImport.update({
  id: '/knowledge_/$id',
  path: '/knowledge/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsProductsRoute = DocsProductsRouteImport.update({
  id: '/docs_/products',
  path: '/docs/products',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIntegrationsRoute = DocsIntegrationsRouteImport.update({
  id: '/docs_/integrations',
  path: '/docs/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsGettingStartedRoute = DocsGettingStartedRouteImport.update({
  id: '/docs_/getting-started',
  path: '/docs/getting-started',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIdRoute = CampaignsIdRouteImport.update({
  id: '/campaigns_/$id',
  path: '/campaigns/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const WarehousePackageIdRoute = WarehousePackageIdRouteImport.update({
  id: '/warehouse_/package_/$id',
  path: '/warehouse/package/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const StoresStoreIdRoute = StoresStoreIdRouteImport.update({
  id: '/stores_/store_/$id',
  path: '/stores/store/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsIdTakebacksRoute = ProgramsIdTakebacksRouteImport.update({
  id: '/programs_/$id_/takebacks',
  path: '/programs/$id/takebacks',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsIdResaleRoute = ProgramsIdResaleRouteImport.update({
  id: '/programs_/$id_/resale',
  path: '/programs/$id/resale',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsIdDashboardRoute = ProgramsIdDashboardRouteImport.update({
  id: '/programs_/$id_/dashboard',
  path: '/programs/$id/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsIdAnalyticsRoute = ProgramsIdAnalyticsRouteImport.update({
  id: '/programs_/$id_/analytics',
  path: '/programs/$id/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const PinTakebackIdRoute = PinTakebackIdRouteImport.update({
  id: '/pin_/takeback_/$id',
  path: '/pin/takeback/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PinResaleIdRoute = PinResaleIdRouteImport.update({
  id: '/pin_/resale_/$id',
  path: '/pin/resale/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/campaign-analytics': typeof CampaignAnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/conversational-analytics': typeof ConversationalAnalyticsRoute
  '/customers': typeof CustomersRoute
  '/docs': typeof DocsRoute
  '/inventory': typeof InventoryRoute
  '/knowledge': typeof KnowledgeRoute
  '/market-intelligence': typeof MarketIntelligenceRoute
  '/nespresso-analytics': typeof NespressoAnalyticsRoute
  '/pin': typeof PinRoute
  '/pricing-engine': typeof PricingEngineRoute
  '/products': typeof ProductsRoute
  '/programs': typeof ProgramsRoute
  '/revenue': typeof RevenueRoute
  '/route-tester': typeof RouteTesterRoute
  '/settings': typeof SettingsRoute
  '/shopify-trade-ins': typeof ShopifyTradeInsRoute
  '/sponsored': typeof SponsoredRoute
  '/stores': typeof StoresRoute
  '/takeback-dashboard': typeof TakebackDashboardRoute
  '/trade-in-analytics': typeof TradeInAnalyticsRoute
  '/treasury': typeof TreasuryRoute
  '/warehouse': typeof WarehouseRouteWithChildren
  '/x402-usage': typeof X402UsageRoute
  '/campaigns/$id': typeof CampaignsIdRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/integrations': typeof DocsIntegrationsRoute
  '/docs/products': typeof DocsProductsRoute
  '/knowledge/$id': typeof KnowledgeIdRoute
  '/knowledge/new': typeof KnowledgeNewRoute
  '/knowledge/test': typeof KnowledgeTestRoute
  '/pin/$id': typeof PinIdRoute
  '/pin/usage': typeof PinUsageRoute
  '/products/$id': typeof ProductsIdRoute
  '/products/import': typeof ProductsImportRoute
  '/programs/$id': typeof ProgramsIdRoute
  '/settings/shopify': typeof SettingsShopifyRoute
  '/sponsored/$id': typeof SponsoredIdRoute
  '/stores/$id': typeof StoresIdRoute
  '/warehouse/overview': typeof WarehouseOverviewRoute
  '/warehouse/': typeof WarehouseIndexRoute
  '/pin/resale/$id': typeof PinResaleIdRoute
  '/pin/takeback/$id': typeof PinTakebackIdRoute
  '/programs/$id/analytics': typeof ProgramsIdAnalyticsRoute
  '/programs/$id/dashboard': typeof ProgramsIdDashboardRoute
  '/programs/$id/resale': typeof ProgramsIdResaleRoute
  '/programs/$id/takebacks': typeof ProgramsIdTakebacksRoute
  '/stores/store/$id': typeof StoresStoreIdRoute
  '/warehouse/package/$id': typeof WarehousePackageIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/campaign-analytics': typeof CampaignAnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/conversational-analytics': typeof ConversationalAnalyticsRoute
  '/customers': typeof CustomersRoute
  '/docs': typeof DocsRoute
  '/inventory': typeof InventoryRoute
  '/knowledge': typeof KnowledgeRoute
  '/market-intelligence': typeof MarketIntelligenceRoute
  '/nespresso-analytics': typeof NespressoAnalyticsRoute
  '/pin': typeof PinRoute
  '/pricing-engine': typeof PricingEngineRoute
  '/products': typeof ProductsRoute
  '/programs': typeof ProgramsRoute
  '/revenue': typeof RevenueRoute
  '/route-tester': typeof RouteTesterRoute
  '/settings': typeof SettingsRoute
  '/shopify-trade-ins': typeof ShopifyTradeInsRoute
  '/sponsored': typeof SponsoredRoute
  '/stores': typeof StoresRoute
  '/takeback-dashboard': typeof TakebackDashboardRoute
  '/trade-in-analytics': typeof TradeInAnalyticsRoute
  '/treasury': typeof TreasuryRoute
  '/x402-usage': typeof X402UsageRoute
  '/campaigns/$id': typeof CampaignsIdRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/integrations': typeof DocsIntegrationsRoute
  '/docs/products': typeof DocsProductsRoute
  '/knowledge/$id': typeof KnowledgeIdRoute
  '/knowledge/new': typeof KnowledgeNewRoute
  '/knowledge/test': typeof KnowledgeTestRoute
  '/pin/$id': typeof PinIdRoute
  '/pin/usage': typeof PinUsageRoute
  '/products/$id': typeof ProductsIdRoute
  '/products/import': typeof ProductsImportRoute
  '/programs/$id': typeof ProgramsIdRoute
  '/settings/shopify': typeof SettingsShopifyRoute
  '/sponsored/$id': typeof SponsoredIdRoute
  '/stores/$id': typeof StoresIdRoute
  '/warehouse/overview': typeof WarehouseOverviewRoute
  '/warehouse': typeof WarehouseIndexRoute
  '/pin/resale/$id': typeof PinResaleIdRoute
  '/pin/takeback/$id': typeof PinTakebackIdRoute
  '/programs/$id/analytics': typeof ProgramsIdAnalyticsRoute
  '/programs/$id/dashboard': typeof ProgramsIdDashboardRoute
  '/programs/$id/resale': typeof ProgramsIdResaleRoute
  '/programs/$id/takebacks': typeof ProgramsIdTakebacksRoute
  '/stores/store/$id': typeof StoresStoreIdRoute
  '/warehouse/package/$id': typeof WarehousePackageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/api-keys': typeof ApiKeysRoute
  '/campaign-analytics': typeof CampaignAnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/conversational-analytics': typeof ConversationalAnalyticsRoute
  '/customers': typeof CustomersRoute
  '/docs': typeof DocsRoute
  '/inventory': typeof InventoryRoute
  '/knowledge': typeof KnowledgeRoute
  '/market-intelligence': typeof MarketIntelligenceRoute
  '/nespresso-analytics': typeof NespressoAnalyticsRoute
  '/pin': typeof PinRoute
  '/pricing-engine': typeof PricingEngineRoute
  '/products': typeof ProductsRoute
  '/programs': typeof ProgramsRoute
  '/revenue': typeof RevenueRoute
  '/route-tester': typeof RouteTesterRoute
  '/settings': typeof SettingsRoute
  '/shopify-trade-ins': typeof ShopifyTradeInsRoute
  '/sponsored': typeof SponsoredRoute
  '/stores': typeof StoresRoute
  '/takeback-dashboard': typeof TakebackDashboardRoute
  '/trade-in-analytics': typeof TradeInAnalyticsRoute
  '/treasury': typeof TreasuryRoute
  '/warehouse': typeof WarehouseRouteWithChildren
  '/x402-usage': typeof X402UsageRoute
  '/campaigns_/$id': typeof CampaignsIdRoute
  '/docs_/getting-started': typeof DocsGettingStartedRoute
  '/docs_/integrations': typeof DocsIntegrationsRoute
  '/docs_/products': typeof DocsProductsRoute
  '/knowledge_/$id': typeof KnowledgeIdRoute
  '/knowledge_/new': typeof KnowledgeNewRoute
  '/knowledge_/test': typeof KnowledgeTestRoute
  '/pin_/$id': typeof PinIdRoute
  '/pin_/usage': typeof PinUsageRoute
  '/products_/$id': typeof ProductsIdRoute
  '/products_/import': typeof ProductsImportRoute
  '/programs_/$id': typeof ProgramsIdRoute
  '/settings_/shopify': typeof SettingsShopifyRoute
  '/sponsored_/$id': typeof SponsoredIdRoute
  '/stores_/$id': typeof StoresIdRoute
  '/warehouse/overview': typeof WarehouseOverviewRoute
  '/warehouse/': typeof WarehouseIndexRoute
  '/pin_/resale_/$id': typeof PinResaleIdRoute
  '/pin_/takeback_/$id': typeof PinTakebackIdRoute
  '/programs_/$id_/analytics': typeof ProgramsIdAnalyticsRoute
  '/programs_/$id_/dashboard': typeof ProgramsIdDashboardRoute
  '/programs_/$id_/resale': typeof ProgramsIdResaleRoute
  '/programs_/$id_/takebacks': typeof ProgramsIdTakebacksRoute
  '/stores_/store_/$id': typeof StoresStoreIdRoute
  '/warehouse_/package_/$id': typeof WarehousePackageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/campaign-analytics'
    | '/campaigns'
    | '/conversational-analytics'
    | '/customers'
    | '/docs'
    | '/inventory'
    | '/knowledge'
    | '/market-intelligence'
    | '/nespresso-analytics'
    | '/pin'
    | '/pricing-engine'
    | '/products'
    | '/programs'
    | '/revenue'
    | '/route-tester'
    | '/settings'
    | '/shopify-trade-ins'
    | '/sponsored'
    | '/stores'
    | '/takeback-dashboard'
    | '/trade-in-analytics'
    | '/treasury'
    | '/warehouse'
    | '/x402-usage'
    | '/campaigns/$id'
    | '/docs/getting-started'
    | '/docs/integrations'
    | '/docs/products'
    | '/knowledge/$id'
    | '/knowledge/new'
    | '/knowledge/test'
    | '/pin/$id'
    | '/pin/usage'
    | '/products/$id'
    | '/products/import'
    | '/programs/$id'
    | '/settings/shopify'
    | '/sponsored/$id'
    | '/stores/$id'
    | '/warehouse/overview'
    | '/warehouse/'
    | '/pin/resale/$id'
    | '/pin/takeback/$id'
    | '/programs/$id/analytics'
    | '/programs/$id/dashboard'
    | '/programs/$id/resale'
    | '/programs/$id/takebacks'
    | '/stores/store/$id'
    | '/warehouse/package/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/campaign-analytics'
    | '/campaigns'
    | '/conversational-analytics'
    | '/customers'
    | '/docs'
    | '/inventory'
    | '/knowledge'
    | '/market-intelligence'
    | '/nespresso-analytics'
    | '/pin'
    | '/pricing-engine'
    | '/products'
    | '/programs'
    | '/revenue'
    | '/route-tester'
    | '/settings'
    | '/shopify-trade-ins'
    | '/sponsored'
    | '/stores'
    | '/takeback-dashboard'
    | '/trade-in-analytics'
    | '/treasury'
    | '/x402-usage'
    | '/campaigns/$id'
    | '/docs/getting-started'
    | '/docs/integrations'
    | '/docs/products'
    | '/knowledge/$id'
    | '/knowledge/new'
    | '/knowledge/test'
    | '/pin/$id'
    | '/pin/usage'
    | '/products/$id'
    | '/products/import'
    | '/programs/$id'
    | '/settings/shopify'
    | '/sponsored/$id'
    | '/stores/$id'
    | '/warehouse/overview'
    | '/warehouse'
    | '/pin/resale/$id'
    | '/pin/takeback/$id'
    | '/programs/$id/analytics'
    | '/programs/$id/dashboard'
    | '/programs/$id/resale'
    | '/programs/$id/takebacks'
    | '/stores/store/$id'
    | '/warehouse/package/$id'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/api-keys'
    | '/campaign-analytics'
    | '/campaigns'
    | '/conversational-analytics'
    | '/customers'
    | '/docs'
    | '/inventory'
    | '/knowledge'
    | '/market-intelligence'
    | '/nespresso-analytics'
    | '/pin'
    | '/pricing-engine'
    | '/products'
    | '/programs'
    | '/revenue'
    | '/route-tester'
    | '/settings'
    | '/shopify-trade-ins'
    | '/sponsored'
    | '/stores'
    | '/takeback-dashboard'
    | '/trade-in-analytics'
    | '/treasury'
    | '/warehouse'
    | '/x402-usage'
    | '/campaigns_/$id'
    | '/docs_/getting-started'
    | '/docs_/integrations'
    | '/docs_/products'
    | '/knowledge_/$id'
    | '/knowledge_/new'
    | '/knowledge_/test'
    | '/pin_/$id'
    | '/pin_/usage'
    | '/products_/$id'
    | '/products_/import'
    | '/programs_/$id'
    | '/settings_/shopify'
    | '/sponsored_/$id'
    | '/stores_/$id'
    | '/warehouse/overview'
    | '/warehouse/'
    | '/pin_/resale_/$id'
    | '/pin_/takeback_/$id'
    | '/programs_/$id_/analytics'
    | '/programs_/$id_/dashboard'
    | '/programs_/$id_/resale'
    | '/programs_/$id_/takebacks'
    | '/stores_/store_/$id'
    | '/warehouse_/package_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  ApiKeysRoute: typeof ApiKeysRoute
  CampaignAnalyticsRoute: typeof CampaignAnalyticsRoute
  CampaignsRoute: typeof CampaignsRoute
  ConversationalAnalyticsRoute: typeof ConversationalAnalyticsRoute
  CustomersRoute: typeof CustomersRoute
  DocsRoute: typeof DocsRoute
  InventoryRoute: typeof InventoryRoute
  KnowledgeRoute: typeof KnowledgeRoute
  MarketIntelligenceRoute: typeof MarketIntelligenceRoute
  NespressoAnalyticsRoute: typeof NespressoAnalyticsRoute
  PinRoute: typeof PinRoute
  PricingEngineRoute: typeof PricingEngineRoute
  ProductsRoute: typeof ProductsRoute
  ProgramsRoute: typeof ProgramsRoute
  RevenueRoute: typeof RevenueRoute
  RouteTesterRoute: typeof RouteTesterRoute
  SettingsRoute: typeof SettingsRoute
  ShopifyTradeInsRoute: typeof ShopifyTradeInsRoute
  SponsoredRoute: typeof SponsoredRoute
  StoresRoute: typeof StoresRoute
  TakebackDashboardRoute: typeof TakebackDashboardRoute
  TradeInAnalyticsRoute: typeof TradeInAnalyticsRoute
  TreasuryRoute: typeof TreasuryRoute
  WarehouseRoute: typeof WarehouseRouteWithChildren
  X402UsageRoute: typeof X402UsageRoute
  CampaignsIdRoute: typeof CampaignsIdRoute
  DocsGettingStartedRoute: typeof DocsGettingStartedRoute
  DocsIntegrationsRoute: typeof DocsIntegrationsRoute
  DocsProductsRoute: typeof DocsProductsRoute
  KnowledgeIdRoute: typeof KnowledgeIdRoute
  KnowledgeNewRoute: typeof KnowledgeNewRoute
  KnowledgeTestRoute: typeof KnowledgeTestRoute
  PinIdRoute: typeof PinIdRoute
  PinUsageRoute: typeof PinUsageRoute
  ProductsIdRoute: typeof ProductsIdRoute
  ProductsImportRoute: typeof ProductsImportRoute
  ProgramsIdRoute: typeof ProgramsIdRoute
  SettingsShopifyRoute: typeof SettingsShopifyRoute
  SponsoredIdRoute: typeof SponsoredIdRoute
  StoresIdRoute: typeof StoresIdRoute
  PinResaleIdRoute: typeof PinResaleIdRoute
  PinTakebackIdRoute: typeof PinTakebackIdRoute
  ProgramsIdAnalyticsRoute: typeof ProgramsIdAnalyticsRoute
  ProgramsIdDashboardRoute: typeof ProgramsIdDashboardRoute
  ProgramsIdResaleRoute: typeof ProgramsIdResaleRoute
  ProgramsIdTakebacksRoute: typeof ProgramsIdTakebacksRoute
  StoresStoreIdRoute: typeof StoresStoreIdRoute
  WarehousePackageIdRoute: typeof WarehousePackageIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/x402-usage': {
      id: '/x402-usage'
      path: '/x402-usage'
      fullPath: '/x402-usage'
      preLoaderRoute: typeof X402UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warehouse': {
      id: '/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof WarehouseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury': {
      id: '/treasury'
      path: '/treasury'
      fullPath: '/treasury'
      preLoaderRoute: typeof TreasuryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade-in-analytics': {
      id: '/trade-in-analytics'
      path: '/trade-in-analytics'
      fullPath: '/trade-in-analytics'
      preLoaderRoute: typeof TradeInAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/takeback-dashboard': {
      id: '/takeback-dashboard'
      path: '/takeback-dashboard'
      fullPath: '/takeback-dashboard'
      preLoaderRoute: typeof TakebackDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores': {
      id: '/stores'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof StoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsored': {
      id: '/sponsored'
      path: '/sponsored'
      fullPath: '/sponsored'
      preLoaderRoute: typeof SponsoredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shopify-trade-ins': {
      id: '/shopify-trade-ins'
      path: '/shopify-trade-ins'
      fullPath: '/shopify-trade-ins'
      preLoaderRoute: typeof ShopifyTradeInsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/route-tester': {
      id: '/route-tester'
      path: '/route-tester'
      fullPath: '/route-tester'
      preLoaderRoute: typeof RouteTesterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revenue': {
      id: '/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof RevenueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing-engine': {
      id: '/pricing-engine'
      path: '/pricing-engine'
      fullPath: '/pricing-engine'
      preLoaderRoute: typeof PricingEngineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin': {
      id: '/pin'
      path: '/pin'
      fullPath: '/pin'
      preLoaderRoute: typeof PinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nespresso-analytics': {
      id: '/nespresso-analytics'
      path: '/nespresso-analytics'
      fullPath: '/nespresso-analytics'
      preLoaderRoute: typeof NespressoAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-intelligence': {
      id: '/market-intelligence'
      path: '/market-intelligence'
      fullPath: '/market-intelligence'
      preLoaderRoute: typeof MarketIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversational-analytics': {
      id: '/conversational-analytics'
      path: '/conversational-analytics'
      fullPath: '/conversational-analytics'
      preLoaderRoute: typeof ConversationalAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaign-analytics': {
      id: '/campaign-analytics'
      path: '/campaign-analytics'
      fullPath: '/campaign-analytics'
      preLoaderRoute: typeof CampaignAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warehouse/': {
      id: '/warehouse/'
      path: '/'
      fullPath: '/warehouse/'
      preLoaderRoute: typeof WarehouseIndexRouteImport
      parentRoute: typeof WarehouseRoute
    }
    '/warehouse/overview': {
      id: '/warehouse/overview'
      path: '/overview'
      fullPath: '/warehouse/overview'
      preLoaderRoute: typeof WarehouseOverviewRouteImport
      parentRoute: typeof WarehouseRoute
    }
    '/stores_/$id': {
      id: '/stores_/$id'
      path: '/stores/$id'
      fullPath: '/stores/$id'
      preLoaderRoute: typeof StoresIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sponsored_/$id': {
      id: '/sponsored_/$id'
      path: '/sponsored/$id'
      fullPath: '/sponsored/$id'
      preLoaderRoute: typeof SponsoredIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/shopify': {
      id: '/settings_/shopify'
      path: '/settings/shopify'
      fullPath: '/settings/shopify'
      preLoaderRoute: typeof SettingsShopifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$id': {
      id: '/programs_/$id'
      path: '/programs/$id'
      fullPath: '/programs/$id'
      preLoaderRoute: typeof ProgramsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products_/import': {
      id: '/products_/import'
      path: '/products/import'
      fullPath: '/products/import'
      preLoaderRoute: typeof ProductsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products_/$id': {
      id: '/products_/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof ProductsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin_/usage': {
      id: '/pin_/usage'
      path: '/pin/usage'
      fullPath: '/pin/usage'
      preLoaderRoute: typeof PinUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin_/$id': {
      id: '/pin_/$id'
      path: '/pin/$id'
      fullPath: '/pin/$id'
      preLoaderRoute: typeof PinIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge_/test': {
      id: '/knowledge_/test'
      path: '/knowledge/test'
      fullPath: '/knowledge/test'
      preLoaderRoute: typeof KnowledgeTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge_/new': {
      id: '/knowledge_/new'
      path: '/knowledge/new'
      fullPath: '/knowledge/new'
      preLoaderRoute: typeof KnowledgeNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge_/$id': {
      id: '/knowledge_/$id'
      path: '/knowledge/$id'
      fullPath: '/knowledge/$id'
      preLoaderRoute: typeof KnowledgeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs_/products': {
      id: '/docs_/products'
      path: '/docs/products'
      fullPath: '/docs/products'
      preLoaderRoute: typeof DocsProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs_/integrations': {
      id: '/docs_/integrations'
      path: '/docs/integrations'
      fullPath: '/docs/integrations'
      preLoaderRoute: typeof DocsIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs_/getting-started': {
      id: '/docs_/getting-started'
      path: '/docs/getting-started'
      fullPath: '/docs/getting-started'
      preLoaderRoute: typeof DocsGettingStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns_/$id': {
      id: '/campaigns_/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof CampaignsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warehouse_/package_/$id': {
      id: '/warehouse_/package_/$id'
      path: '/warehouse/package/$id'
      fullPath: '/warehouse/package/$id'
      preLoaderRoute: typeof WarehousePackageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores_/store_/$id': {
      id: '/stores_/store_/$id'
      path: '/stores/store/$id'
      fullPath: '/stores/store/$id'
      preLoaderRoute: typeof StoresStoreIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$id_/takebacks': {
      id: '/programs_/$id_/takebacks'
      path: '/programs/$id/takebacks'
      fullPath: '/programs/$id/takebacks'
      preLoaderRoute: typeof ProgramsIdTakebacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$id_/resale': {
      id: '/programs_/$id_/resale'
      path: '/programs/$id/resale'
      fullPath: '/programs/$id/resale'
      preLoaderRoute: typeof ProgramsIdResaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$id_/dashboard': {
      id: '/programs_/$id_/dashboard'
      path: '/programs/$id/dashboard'
      fullPath: '/programs/$id/dashboard'
      preLoaderRoute: typeof ProgramsIdDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$id_/analytics': {
      id: '/programs_/$id_/analytics'
      path: '/programs/$id/analytics'
      fullPath: '/programs/$id/analytics'
      preLoaderRoute: typeof ProgramsIdAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin_/takeback_/$id': {
      id: '/pin_/takeback_/$id'
      path: '/pin/takeback/$id'
      fullPath: '/pin/takeback/$id'
      preLoaderRoute: typeof PinTakebackIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pin_/resale_/$id': {
      id: '/pin_/resale_/$id'
      path: '/pin/resale/$id'
      fullPath: '/pin/resale/$id'
      preLoaderRoute: typeof PinResaleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface WarehouseRouteChildren {
  WarehouseOverviewRoute: typeof WarehouseOverviewRoute
  WarehouseIndexRoute: typeof WarehouseIndexRoute
}

const WarehouseRouteChildren: WarehouseRouteChildren = {
  WarehouseOverviewRoute: WarehouseOverviewRoute,
  WarehouseIndexRoute: WarehouseIndexRoute,
}

const WarehouseRouteWithChildren = WarehouseRoute._addFileChildren(
  WarehouseRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  ApiKeysRoute: ApiKeysRoute,
  CampaignAnalyticsRoute: CampaignAnalyticsRoute,
  CampaignsRoute: CampaignsRoute,
  ConversationalAnalyticsRoute: ConversationalAnalyticsRoute,
  CustomersRoute: CustomersRoute,
  DocsRoute: DocsRoute,
  InventoryRoute: InventoryRoute,
  KnowledgeRoute: KnowledgeRoute,
  MarketIntelligenceRoute: MarketIntelligenceRoute,
  NespressoAnalyticsRoute: NespressoAnalyticsRoute,
  PinRoute: PinRoute,
  PricingEngineRoute: PricingEngineRoute,
  ProductsRoute: ProductsRoute,
  ProgramsRoute: ProgramsRoute,
  RevenueRoute: RevenueRoute,
  RouteTesterRoute: RouteTesterRoute,
  SettingsRoute: SettingsRoute,
  ShopifyTradeInsRoute: ShopifyTradeInsRoute,
  SponsoredRoute: SponsoredRoute,
  StoresRoute: StoresRoute,
  TakebackDashboardRoute: TakebackDashboardRoute,
  TradeInAnalyticsRoute: TradeInAnalyticsRoute,
  TreasuryRoute: TreasuryRoute,
  WarehouseRoute: WarehouseRouteWithChildren,
  X402UsageRoute: X402UsageRoute,
  CampaignsIdRoute: CampaignsIdRoute,
  DocsGettingStartedRoute: DocsGettingStartedRoute,
  DocsIntegrationsRoute: DocsIntegrationsRoute,
  DocsProductsRoute: DocsProductsRoute,
  KnowledgeIdRoute: KnowledgeIdRoute,
  KnowledgeNewRoute: KnowledgeNewRoute,
  KnowledgeTestRoute: KnowledgeTestRoute,
  PinIdRoute: PinIdRoute,
  PinUsageRoute: PinUsageRoute,
  ProductsIdRoute: ProductsIdRoute,
  ProductsImportRoute: ProductsImportRoute,
  ProgramsIdRoute: ProgramsIdRoute,
  SettingsShopifyRoute: SettingsShopifyRoute,
  SponsoredIdRoute: SponsoredIdRoute,
  StoresIdRoute: StoresIdRoute,
  PinResaleIdRoute: PinResaleIdRoute,
  PinTakebackIdRoute: PinTakebackIdRoute,
  ProgramsIdAnalyticsRoute: ProgramsIdAnalyticsRoute,
  ProgramsIdDashboardRoute: ProgramsIdDashboardRoute,
  ProgramsIdResaleRoute: ProgramsIdResaleRoute,
  ProgramsIdTakebacksRoute: ProgramsIdTakebacksRoute,
  StoresStoreIdRoute: StoresStoreIdRoute,
  WarehousePackageIdRoute: WarehousePackageIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
